// extracted by mini-css-extract-plugin
export default {"spiner":"Users_spiner__hhbpB"};